<div class="row">
  <app-card type="attention"
    borderClass="border-default">
    <div icon-title><span class="fa fa-search"></span></div>
    <div left-title>
      <h4 class="mb-0">Policy Document Search</h4>
    </div>
    <div card-content-container>
      <form [formGroup]="policyDocumentFormGroup">

        <div class="pb-4">{{direction}}</div>

        <div class="row mb-2 mt-5">
          <div class="col-md-12">
            <div class="px-4 zero-pd ">
              <div class="row px-3 zero-pd ">
                <div class="leftmargin">
                  <div class="marginup"
                    style="width: 115%; margin-left: -10px;">
                    <label>Line of Business</label>
                    <ng-multiselect-dropdown class="col-10 policy-period ms-3 w-35"
                      placeholder="Line of Business"
                      [settings]="policyPeriodDropdownConfig"
                      [data]="policyLOB"
                      [disabled]="!policyLOB"
                      formControlName="policyLineOfBusiness"
                      (onSelect)="onLobChange()"
                      (onDeSelect)="onLobDeselect($event)"
                      (onSelectAll)="onLobSelectDeselectAll($event)"
                      (onDeSelectAll)="onLobSelectDeselectAll($event)"
                      [attr.data-dl]="JSON.stringify({da_track: 'true'})">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2 mt-5">
          <div class="col-md-12">
            <div class="px-4 zero-pd ">
              <div class="row px-3 zero-pd ">
                <div class="leftmargin">
                  <div class="marginup"
                    style="width: 115%; margin-left: -10px;">
                    <label>Policy Pricing Plan</label>
                    <ng-multiselect-dropdown class="col-10 policy-period ms-3 w-35"
                      placeholder="Policy Pricing Plan"
                      [settings]="policyPeriodDropdownConfig"
                      [data]="pricingPlans"
                      [disabled]="!pricingPlans"
                      formControlName="policyPricingPlanDropdown"
                      (onSelect)="onPricingPolicyChange()"
                      (onDeSelect)="onPricingPolicyDeselect($event)"
                      (onSelectAll)="onPricingPolicySelectDeselectAll($event)"
                      (onDeSelectAll)="onPricingPolicySelectDeselectAll($event)"
                      [attr.data-dl]="JSON.stringify({da_track: 'true'})">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2 mt-5">
          <div class="col-md-12">
            <div class="px-4 zero-pd ">
              <div class="row px-3 zero-pd ">
                <div class="leftmargin">
                  <div class="marginup"
                    style="width: 115%; margin-left: -10px;">
                    <label>State</label>
                    <ng-multiselect-dropdown class="col-10 policy-period ms-3 w-35"
                      placeholder="State"
                      [settings]="policyPeriodDropdownConfig"
                      [data]="state"
                      [disabled]="!state"
                      formControlName="policyStateDropdown"
                      (onSelect)="onStateChange()"
                      (onDeSelect)="onStateDeselect($event)"
                      (onSelectAll)="onStateSelectDeselectAll($event)"
                      (onDeSelectAll)="onStateSelectDeselectAll($event)"
                      [attr.data-dl]="JSON.stringify({da_track: 'true'})">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2 mt-5">
          <div class="col-md-12">
            <div class="px-4 zero-pd ">
              <div class="row px-3 zero-pd ">
                <div class="leftmargin">
                  <div class="marginup"
                    style="width: 115%; margin-left: -10px;">
                    <label>Policy Period</label>
                    <ng-multiselect-dropdown class="col-10 policy-period ms-3 w-35"
                      placeholder="Policy Period"
                      [settings]="policyPeriodDropdownConfig"
                      [data]="policyPeriod"
                      [disabled]="!policyPeriod"
                      formControlName="policyPeriodDropdown"
                      (onSelect)="onPolicyPeriodChange()"
                      (onDeSelect)="onPolicyPeriodDeselect($event)"
                      (onSelectAll)="onPolicyPeriodSelectDeselectAll($event)"
                      (onDeSelectAll)="onPolicyPeriodSelectDeselectAll($event)"
                      [attr.data-dl]="JSON.stringify({da_track: 'true'})">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row mb-2 mt-5">
          <div class="col-md-12">
            <div class="px-4 zero-pd ">
              <div class="row px-3 zero-pd ">
                <div class="leftmargin">
                  <div class="marginup"
                    style="width: 115%; margin-left: -10px;">
                    <label>Policy Number</label>
                    <ng-multiselect-dropdown class="col-10 policy-period ms-3 w-35"
                      placeholder="Policy Number"
                      [settings]="policyNumberDropdownConfig"
                      [data]="policyNumber"
                      [disabled]="!policyNumber"
                      formControlName="policyNumberDropdown"
                      (onSelect)="onPolicyNumberChange()"
                      (onDeSelect)="onPolicyNumberDeselect($event)"
                      (onSelectAll)="onPolicyNumberSelectDeselectAll($event)"
                      (onDeSelectAll)="onPolicyNumberSelectDeselectAll($event)"
                      [attr.data-dl]="JSON.stringify({da_track: 'true'})">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="showErrorMsg"
          style="color:#b83b2f; font-size: 1.1em;margin-bottom:15px; margin-left: 2px; display: flex; align-items: center;">
          <i class="fa fa-exclamation-circle"
            aria-hidden="true"
            style="margin-right: 6px; margin-top: -25px;"></i>
          {{ customErrorMessage }}
        </div>
        <div class="d-flex justify-content-end md-b">
          <button class="btn-sm btn-primary"
            style="margin-right: -15px;"
            [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            (click)="submit()">Search</button>
        </div>
      </form>

    </div>
  </app-card>
</div>